import { Component, Input } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { CompteService } from '../../../@core/data/rest/compte/compte-service';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { Compte } from '../../../@core/data/model/compte';
import { CatSelectComponent } from './catselect.component';
import { plainToClass } from 'class-transformer';
import { AuthService } from '../../../auth/auth.service';
import { CatProduit } from '../../../@core/data/model/catproduit';
import { CatProduitService } from '../../../@core/data/rest/catproduit/catproduit-service';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-cat',
  templateUrl: './catform.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class CatFormComponent {

  @Input() catEdit: CatProduit;
  @Input() catRacine: CatProduit;


  selectedItems = [];
  dropdownSettings = {};

  dialogIsNotShow = true;

  isLoad = false;

  constructor(
      protected dialogRef: NbDialogRef<CatFormComponent>,
      public catService: CatProduitService,
      public sharedMethods: SharedMethods,
      public authService: AuthService,
      private dialogService: NbDialogService) {



  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {


    // console.log(this.catEdit);

    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close()

    });




    if (this.catEdit.id !== 0 && this.catEdit.id !== undefined && this.catEdit.id !== null) {

      this.isLoad = true;
      this.dialogIsNotShow = false;
      this.catService.getCat(this.catEdit.id).then( cat => {

        this.catEdit = cat;
        this.isLoad = false;
        this.dialogIsNotShow = true;

      });
    }

  }


  selectCat() {

    this.dialogIsNotShow = false;

    let parent: CatProduit;

    if (this.catEdit.parent !== undefined && this.catEdit.parent !== null)
    parent = this.catEdit.parent;


    const closeOnBackdropClick = true;
    this.dialogService.open(CatSelectComponent, {
      closeOnBackdropClick,
      context: {
        cat: this.catEdit,
        parent: parent,
      },
    }).onClose.subscribe(data => {

        if ( data !== undefined) {

          // alert(JSON.stringify(data));

          this.catEdit.parent = data;
          // this.catEdit.type_compte = data.type_compte;

          /* if (typeEdit === 'update' ) {
            this.source.update(compt, data);
            this.sharedMethods.sweetalert('success', ' Compte Modifié', '');
          }

          if (typeEdit === 'add' ) {
            this.source.prepend(data);
            this.sharedMethods.sweetalert('success', ' Compte créer avec succèss', '');
          } */

        }

        this.dialogIsNotShow = true;
    });

  }

  cancel() {
    if (this.catService.iSconnecting === false) {
        this.dialogRef.close();
    }
  }

  submit() {
    // alert(JSON.stringify(this.produitEdit));
    // alert('nature: ' + this.reglementEdit.nature_reglement + ' montant: ' + this.reglementEdit.montant.toString());
    // this.dialogRef.close();

    // this.reglementEdit.date_flux = this.sharedMethods.converNgbDateStructToString(this.dateReglement);

   let valid: Validator;
    valid = this.sharedMethods.validateCat(this.catEdit, this.catService.catproduits);

    if (valid.result) {

        // this.dialogRef.close(this.partenaireEdit);

        if (this.catService.iSconnecting === false) {


            this.catService.saveCatProduit(this.catEdit).then( compte => {

              /* this.catEdit.id = compte.id;
              this.dialogRef.close(this.catEdit); */
              this.dialogRef.close(plainToClass(Compte, compte as object));
              // alert(JSON.stringify(this.fluxstockedit));

            }, (err) => {

                this.sharedMethods.errorApiShow(err.error.code, err.error.message);

            });
        }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


 }


}
